import { Label, LabelValue } from '../typography';

interface IDetailItemProps {
  label: string;
  placeholder?: string;
  value?: string;
}

export const DetailItem: React.FC<IDetailItemProps> = ({ label, placeholder, value }) => (
  <div className="w-full flex xs:flex-col sm:flex-row">
    <Label>{label}</Label>
    <LabelValue placeholder={placeholder}>{value}</LabelValue>
  </div>
);
